<ng-container *ngIf="resultadoReporte">
    <app-servicios-reporte [resultadoReporte]="resultadoReporte"></app-servicios-reporte>
</ng-container>